import React, { useState } from 'react';
import {
  WBButton,
  WBFlex,
  WBTextFieldV2,
  WBTypography,
} from '@admiin-com/ds-web';
import { Dialog, DialogContent, DialogActions, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface RejectModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (rejectionNote: string) => void;
  loading?: boolean;
}

export const RejectModal = ({
  open,
  onClose,
  onConfirm,
  loading = false,
}: RejectModalProps) => {
  const { t } = useTranslation();
  const [rejectionNote, setRejectionNote] = useState('');

  const handleConfirm = () => {
    if (rejectionNote.trim()) {
      onConfirm(rejectionNote);
      setRejectionNote('');
    }
  };

  const handleClose = () => {
    setRejectionNote('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <StyledDialogContent>
        <WBTypography variant="h5" fontWeight="bold" mb={2}>
          {t('rejectTask', {
            ns: 'taskbox',
          })}
        </WBTypography>
        <WBTypography variant="body1" color="text.secondary" mb={3}>
          {t('rejectTaskDescription', {
            ns: 'taskbox',
          })}
        </WBTypography>
        <WBTextFieldV2
          multiline
          rows={4}
          value={rejectionNote}
          onChange={(e) => setRejectionNote(e.target.value)}
          placeholder={t('rejectionNotePlaceholder', {
            ns: 'taskbox',
          })}
          fullWidth
          required
        />
      </StyledDialogContent>
      <DialogActions>
        <WBFlex gap={2} p={2} width="100%" justifyContent="flex-end">
          <WBButton variant="outlined" onClick={handleClose} disabled={loading}>
            {t('cancel', { ns: 'taskbox', defaultValue: 'Cancel' })}
          </WBButton>
          <WBButton
            variant="contained"
            color="error"
            onClick={handleConfirm}
            disabled={!rejectionNote.trim() || loading}
            loading={loading}
          >
            {t('confirmReject', {
              ns: 'taskbox',
              defaultValue: 'Confirm Rejection',
            })}
          </WBButton>
        </WBFlex>
      </DialogActions>
    </Dialog>
  );
};

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(3),
}));
